<div class="row legal-disclaimer">
  <div class="col-md-8 legal-disclaimer-container">
    <p>{{legalDisclaimerDescription}}</p>
  </div>
</div>
